export const ADD_IRREVOCABLE_MODAL_CONSTANTS = {
    TRIGGER_EVENT_LABEL_TEXT: "Trigger Event for Trust Activation?",
}

export const BASIC_INFORMATION_CONSTANTS = {
    TITLE_LABEL_TEXT: "Basic Information"
}

export const BASIC_DETAILS_CONSTANTS = {
    BASIC_DETAILS_SECTION_LABEL_TEXT: "Basic Details",
    FLOWCHART_NAME_LABEL_TEXT: "Flowchart Name",
    FLOWCHART_NAME_PLACEHOLDER_TEXT: "Example, John's Estate Plan",
    FLOWCHART_NAME_SUB_TEXT: "Recommend titling with Estate Plan at the end, e.g., John's Estate Plan.",
    LEGAL_NAME_LABEL_TEXT: "Legal Name of Trust or Entity",
    NICKNAME_LABEL_TEXT: "Nickname",
    NICKNAME_SUB_TEXT: "This is what will display in the flowchart visual.",
    DATE_CREATED_LABEL_TEXT: "Date Created",
    RECORD_OF_AMENDMENTS_LABEL_TEXT: "Record of Amendments",
    POUR_OVER_WILL_LABEL_TEXT: "Is this a pour over will?",
    ESTATE_TYPE_MISC_LABEL_TEXT: "In or Out of Estate",
    VISUAL_TREATMENT_MISC_LABEL_TEXT: "Visual Treatment"
}

export const TRUST_DETAILS_CONSTANTS = {
    TRUST_DETAILS_SECTION_LABEL_TEXT: "Trust Details",
    GRANTORS_LABEL_TEXT: "Grantors",
    TRUSTEES_LABEL_TEXT: "Trustees",
    FUNDING_LABEL_TEXT: "Funding",
    FUNDING_SUB_TEXT: "Funding details could include total asset value, specific assets you want to highlight (e.g. a house), where the funding is coming from (e.g. a specific trust or account), or other critical details related to how the trust is funded.",
    DISTRIBUTIONS_LABEL_TEXT: "Distributions",
    TRUST_TERMINATION_LABEL_TEXT: "Does this trust terminate upon a specific death?",
    INVESTMENT_ADVISOR_LABEL_TEXT: "Investment Advisor",
    TRUST_PROTECTOR_LABEL_TEXT: "Trust Protector",
    TRUST_JURISDICTION_LABEL_TEXT: "Trust Jurisdiction",
    WHOSE_DEATH_LABEL_TEXT: "Whose Death?",
}

export const MISCELLANEOUS_DETAILS_CONSTANTS = {
    MISCELLANEOUS_DETAILS_SECTION_LABEL_TEXT: "Additional Details (Optional)",
    FUNDING_LABEL_TEXT: "Funding",
    FUNDING_SUB_TEXT: "Funding details could include total asset value, specific assets you want to highlight (e.g. a house), where the funding is coming from (e.g. a specific trust or account), or other critical details related to how the trust is funded.",
    ADDITIONAL_DETAILS_TEXT: "Additional Details"
}

export const WILL_DETAILS_CONSTANTS = {
    WILL_DETAILS_SECTION_LABEL_TEXT: "Will Details",
    EXECUTOR_LABEL_TEXT: "Executor",
    GUARDIANS_FOR_MINORS_LABEL_TEXT: "Guardian for Minors",
    FUNDING_LABEL_TEXT: "Funding",
    FUNDING_SUB_TEXT: "Funding details could include total asset value, specific assets you want to highlight (e.g. a house), where the funding is coming from (e.g. a specific trust or account), or other critical details related to how the trust is funded.",
    EXERCISES_OF_POA_LABEL_TEXT: "Exercises of Powers of Appointment",
    EXERCISES_OF_POA_SUB_TEXT: "Include details of PoA that the decedent is exercising.",
    TANGIBLE_PERSONAL_PROPERTY_LABEL_TEXT: "Tangible Personal Property",
    SPECIFIC_BEQUESTS_LABEL_TEXT: "Specific Bequests",
    JURISDICTION_LABEL_TEXT: "Jurisdiction",
}

export const BENEFICIARIES_AT_FIRST_DEATH_CONSTANTS = {
    TITLE_LABEL_TEXT: "Beneficiaries at First Death",
    TITLE_SUB_TEXT: "Begin by adding new trusts or distributions to be created upon death of first grantor."
}

export const TRUST_FORM_CONSTANTS = {
    TRUST_NAME_LABEL_TEXT: "Trust Name",
    TAGS_LABEL_TEXT: "GST Tags",
    TRUSTEES_LABEL_TEXT: "Trustees",
    FUNDING_LABEL_TEXT: "Funding",
    FUNDING_SUB_TEXT: "Funding details could include total asset value, specific assets you want to highlight (e.g. a house), where the funding is coming from (e.g. a specific trust or account), or other critical details related to how the trust is funded.",
    DISTRIBUTIONS_LABEL_TEXT: "Distributions",
    DISTRIBUTIONS_SUB_TEXT: "Categories can include: emergencies, medical needs, health, education, support & " +
        "maintenance, comfort, best interest & welfare, pleasure/happiness, trustee's sole discretion, etc. for " +
        "e.g., Mandatory income and discretionary principal in the trustee's discretion for support in reasonable " +
        "comfort and health",
    TERMINATION_LABEL_TEXT: "Termination"
}

export const NON_TRUST_FORM_CONSTANTS = {
    CHARITY_NAME_LABEL_TEXT: "Charity Name",
    OUTRIGHT_NAME_LABEL_TEXT: "Name of Recipient",
    FUNDING_LABEL_TEXT: "Funding",
    FUNDING_SUB_TEXT: "Funding details could include total asset value, specific assets you want to highlight (e.g. a house), where the funding is coming from (e.g. a specific trust or account), or other critical details related to how the trust is funded.",
    ADDITIONAL_DETAILS_LABEL_TEXT: "Additional Details",
    CHARITY_ADDITIONAL_DETAILS_SUB_TEXT: "Add any additional details needed.",
    OUTRIGHT_ADDITIONAL_DETAILS_SUB_TEXT: "Add any additional details needed, for e.g. accounting for per stirpes."
}

export const REMAINDER_BENEFICIARIES_CONSTANTS = {
    TITLE_LABEL_TEXT: "Remainder Beneficiaries",
    TITLE_SUB_TEXT: "Begin by adding new trusts or distributions for remainder beneficiaries.",
    ADDITIONAL_LAYER_SECTION_TITLE: "Additional Distribution Layer",
    ADDITIONAL_LAYER_BUTTON_TEXT: "Add Layer",
    ADDITIONAL_LAYER_HELPER_TEXT_PREFIX: "You can create an Additional Distribution Layer in your flowchart after including at least one ",
    ADDITIONAL_LAYER_HELPER_TEXT_SUFFIX: " distribution in the Remainder Beneficiaries section."
}

export const ADDITIONAL_DISTRIBUTIONS_CONSTANTS = {
    TITLE_SUB_TEXT: "Begin by adding new trusts or distributions.",
    ADDITIONAL_LAYER_SECTION_TITLE: "Additional Distribution Layer",
    ADDITIONAL_LAYER_BUTTON_TEXT: "Add Layer",
    ADDITIONAL_LAYER_HELPER_TEXT_PREFIX: "You can create an Additional Distribution Layer in your flowchart after including at least one ",
    ADDITIONAL_LAYER_HELPER_TEXT_SUFFIX: " distribution in the Remainder Beneficiaries section."
}

export const VALIDATION_CONSTANTS = {
    REQUIRED_FIELDS_MESSAGE_TEXT: "Required fields missing.",
    REQUIRED_FIELDS_DETAIL_TEXT: "All required fields must be entered to save a flowchart.",
    REQUIRED_FIELDS_FLOWCHART_NAME_TEXT: "Flowchart Name is required.",
    DUPLICATE_FIELDS_FLOWCHART_NAME_TEXT: "Flowchart Name already exists.",
    REQUIRED_FIELDS_ESTATE_ITEM_TEXT: "Estate Item is required.",
}

export const DISTRIBUTION_CONSTANTS = {
    DISTRIBUTION_EVENT_TRIGGER: "What is the event trigger for this distribution layer?",
    DISTRIBUTION_EVENT_SUBTEXT: "Additional details are required for each event type.",
    DISTRIBUTION_CONSTANTS_DEATH: "Whose Death? ",
    DISTRIBUTION_CONSTANTS_AGE_ATTAINMENT: "Whose Age Attainment?",
    DISTRIBUTION_CONSTANTS_OTHER: "Event Name",
}

export const LEGEND_COLOR_CONSTANTS = {
    OUTRIGHT: "#F1B040",
    CHARITY: "#D6ACCF",
    TRUST: "#05676E",
    WILL: "#A5CF68",
    MISCELLANEOUS: "#B0B0B0"
}